import { cn, sevClass } from "@/lib/util";

export function SeverityBadge({ sev, className }) {
  const cls = sevClass(sev);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 px-2 py-0.5 border font-mono text-[10px] tracking-widest uppercase",
        cls, className
      )}
      style={{ backgroundColor: `hsl(var(--sev-${sev}) / 0.1)` }}
      data-testid={`severity-${sev}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: `hsl(var(--sev-${sev}))` }}
      />
      {sev}
    </span>
  );
}
